module.exports = __webpack_public_path__ + "static/img/arrow-left-1.6daff1d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/arrow-left-1.png
// module id = nZKN
// module chunks = 4